import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import AssetSelect from '../../components/assetselect';
import Big from 'big.js';

class InitialOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  setPercentOf(asset, field, percent) {
    const { amountChange, availableBalance } = this.props;
    const maxBal = availableBalance(asset);
    let usePercent;
    let useMaxBal;
    if (percent) {
      usePercent = new Big(percent / 100);
    }
    if (maxBal) {
      useMaxBal = new Big(maxBal);
    }

    const useBal = usePercent.times(useMaxBal);

    let useEvent;
    if (field && useBal) {
      useEvent = {
        target: {
          id: field,
          value: useBal.toString(),
        },
      };
      amountChange(useEvent);
    }
  }

  render() {
    const {
      user,
      otcDisabled,
      tradesDisabled,
      aAssets,
      bAssets,
      exchA,
      exchB,
      tradeAlt,
      tradeAmount,
      tradeSpend,
      checkOrder,
      assetChange,
      amountChange,
      availableBalance,
      assetValue,
      tradeType,
      currencySign,
      pristine,
      hasEnoughBalance,
      availableSpend,
      getOtcDefaults,
      isOfType,
      feesFail,
      pairUnavailable,
      promoCode,
      promoChange,
    } = this.props;

    const aAssetLoop = aAssets && aAssets.map((item, index) => (
      <option key={index} value={item.asset}>{item.name}</option>
    ));

    const bAssetLoop = bAssets && bAssets.map((item, index) => (
      <option key={index} value={item.asset}>{item.name}</option>
    ));

    let useA;
    let useB;
    if (exchA) {
      useA = exchA;
    }
    if (exchB) {
      useB = exchB;
    }
    if (useA === 'silv') {
      useA = 'silver';
    }
    if (useB === 'silv') {
      useB = 'silver';
    }

    let currency;
    if (user && user.me && user.me.defaults && user.me.defaults.currencyHandle) {
      currency = user.me.defaults.currencyHandle;
    }
    let assetRate;
    if (assetValue) {
      if (tradeType === 'BUY') {
        assetRate = assetValue.bid;
      }
      if (tradeType === 'SELL') {
        assetRate = assetValue.ask;
      }
    }
    let fiatTotal = Number(0);
    if (tradeType === 'BUY') {
      if (assetRate && tradeSpend) {
        fiatTotal = Number(tradeSpend / assetRate).toFixed(2);
      }
    }
    if (tradeType === 'SELL') {
      if (assetRate && tradeAmount) {
        fiatTotal = Number(tradeAmount / assetRate).toFixed(2);
      }
    }

    const minAsset = exchA;

    const otcDefaults = getOtcDefaults(minAsset);

    let underMinimum;
    if ((otcDefaults && otcDefaults.min) && ((tradeSpend > 0) && (tradeAmount > 0))) {
      underMinimum = Number(tradeAmount) < Number(otcDefaults.min);
    }

    const otcFail = feesFail;

    const buyCompleted = (tradeSpend > 0) && (tradeAmount > 0) && exchA && exchB && !otcDisabled && !pristine && availableSpend && !underMinimum && !otcFail && !pairUnavailable && !tradesDisabled;
    // if (tradeAlt) {
    //   buyCompleted = (tradeSpend > 0) && (tradeAmount > 0) && exchA && exchB && !otcDisabled && !pristine && availableSpend;
    // }

    return (
      <div>
        <div>
          {tradesDisabled && (
            <div className="status alert">
              <span>
                Vaultoro Direct is temporarily disabled.
                <br />
              </span>
              Due to increased KYC/due diligence requirements, Vaultoro Direct has been temporarily disabled. Please contact support for more info, or check back later.
            </div>
          )}
          {otcDisabled && (
            <div className="status alert">
              <span>
                Vaultoro Direct is currently disabled.
                <br />
              </span>
              Please contact support for more info, or check back later.
            </div>
          )}
          {otcFail && (
            <div className="status warn">
              <span>
                Vaultoro Direct encountered a problem.
                <br />
              </span>
              Please check back later, or contact support if problem persists.
            </div>
          )}
          {pairUnavailable && (
            <div className="status warn">
              <span>
                Your selected trading pair is currently unavailable.
                <br />
              </span>
              Please check back later, or contact support if problem persists.
            </div>
          )}
          <div style={{marginBottom: '30px'}}>
            <p style={{marginTop: '0px'}}>
              Vaultoro Direct is an easy solution for buying and selling assets.
            </p>
          </div>
        </div>
        <div>
          <div>
            <div className="lr-p">
              Pay with
              <span
                className="mute"
                style={availableSpend ? null : { color: 'rgb(255, 82, 117)', opacity: 1 }}
              >
                Available {exchB.toUpperCase()}: {availableBalance('exchB')}
              </span>
            </div>
            <div className="input-drop" style={{ marginBottom: '8px' }}>
              <input className="input id-i" type="number" name="tradeSpend" placeholder="0" value={tradeSpend} id="tradeSpend" onChange={amountChange} min="0" step="0.000001" />
              <AssetSelect
                onChange={assetChange}
                curVal={exchB}
                options={bAssets}
                optName="name"
                optVal="asset"
                useId="exchB"
                assetSel
              />
            </div>
            <div className="lr-p lr-p-a">
              <div className="mute">
                &#8776;&nbsp;
                <span>
                  {currencySign(currency)}
                  {Number(fiatTotal).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    },
                  )}
                </span>
              </div>
              <div style={{ display: 'flex' }}>
                <button
                  type="button"
                  className="vlt-button sm-b dark-b"
                  onClick={() => this.setPercentOf('exchB', 'tradeSpend', 25)}
                >
                  <span>
                    25%
                  </span>
                </button>
                <button
                  type="button"
                  className="vlt-button sm-b dark-b"
                  style={{ margin: '0px 8px' }}
                  onClick={() => this.setPercentOf('exchB', 'tradeSpend', 50)}
                >
                  <span>
                    50%
                  </span>
                </button>
                <button
                  type="button"
                  className="vlt-button sm-b dark-b"
                  onClick={() => this.setPercentOf('exchB', 'tradeSpend', 100)}
                >
                  <span>
                    100%
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div>
            <div>
              <div className="lr-p">
                Receive
              </div>
              <div className="input-drop" style={{ marginBottom: '8px' }}>
                <input className="input id-i" type="number" name="tradeAmount" placeholder="0" value={tradeAmount} id="tradeAmount" onChange={amountChange} min="0" step="0.000001" />
                <AssetSelect
                  onChange={assetChange}
                  curVal={exchA}
                  options={aAssets}
                  optName="name"
                  optVal="asset"
                  useId="exchA"
                  assetSel
                />
              </div>
              <div className="lr-p lr-p-a">
                <div
                  className="mute"
                  style={underMinimum ? { color: 'rgb(255, 82, 117)', opacity: 1 } : null}
                >
                  Minimum&nbsp;
                  {minAsset.toUpperCase()}
                  :&nbsp;
                  {otcDefaults && otcDefaults.min ? (
                    otcDefaults.min
                  ) : (
                    ''
                  )}
                  {isOfType(minAsset, 'METAL') ? (
                    'g'
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>

          <div>
            <div>
              <div className="lr-p">
                Promo Code/Coupon
              </div>
              <div className="input-drop" style={{ marginBottom: '8px' }}>
                <input className="input id-i" type="text" name="promoCode" placeholder="" value={promoCode} id="promoCode" onChange={promoChange} min="0" />
              </div>
            </div>
          </div>

        </div>
        <div className="button-area">
          <button type="button" className="vlt-btn" disabled={!buyCompleted} onClick={checkOrder} style={{ width: '100%' }}>
            <span>
              Next
            </span>
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
  assetValue: state.order.assetValue,
});

export default connect(mapStateToProps)(InitialOrder);
